const VIEWER= {
    BASE: "Viewer",
    MAIN: undefined,
    CARS: {
        _BASE: undefined,
        LIST: undefined,
        DETAIL: undefined
    },
    FIELDS: {
        _BASE: undefined,
        LIST: undefined,
        DETAIL: undefined
    },
    ORDERS: {
        _BASE: undefined,
        LIST: undefined,
        DETAIL: undefined,
        FILE: undefined
    },
    VISITORS: {
        _BASE: undefined,
        LIST: undefined,
        DETAIL: undefined
    },
    ORGANIZATIONS: {
        _BASE: undefined,
        LIST: undefined
    }
};

VIEWER.MAIN = `${VIEWER.BASE}|Main`

VIEWER.CARS._BASE = `${VIEWER.BASE}|Cars`
VIEWER.CARS.LIST = `${VIEWER.CARS._BASE}|List`
VIEWER.CARS.DETAIL = `${VIEWER.CARS._BASE}|Detail`

VIEWER.FIELDS._BASE = `${VIEWER.BASE}|Fields`
VIEWER.FIELDS.LIST = `${VIEWER.FIELDS._BASE}|List`
VIEWER.FIELDS.DETAIL = `${VIEWER.FIELDS._BASE}|Detail`

VIEWER.ORDERS._BASE = `${VIEWER.BASE}|Orders`
VIEWER.ORDERS.LIST = `${VIEWER.ORDERS._BASE}|List`
VIEWER.ORDERS.DETAIL = `${VIEWER.ORDERS._BASE}|Detail`
VIEWER.ORDERS.FILE = `${VIEWER.ORDERS._BASE}|File`

VIEWER.VISITORS._BASE = `${VIEWER.BASE}|Visitors`
VIEWER.VISITORS.LIST = `${VIEWER.VISITORS._BASE}|List`
VIEWER.VISITORS.DETAIL = `${VIEWER.VISITORS._BASE}|Detail`

VIEWER.ORGANIZATIONS._BASE = `${VIEWER.BASE}|Organizations`
VIEWER.ORGANIZATIONS.LIST = `${VIEWER.ORGANIZATIONS._BASE}|List`

export default {
    ...VIEWER
}
